import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  StaffApplicationStatusEnum,
  staffApplicationStatusEnumMapping
} from '../../../lib/types/enums/staff-application/staff-application-status.enum'
import { StaffApplicationStatusInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedOption } from '../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<StaffApplicationStatusInput> = z.object({
  status: createEnumSchema({ fieldName: 'statut', enumType: StaffApplicationStatusEnum })
})

type StaffApplicationStatusFormProps = BaseFormProps<StaffApplicationStatusInput> & {
  className?: string
}

const StaffApplicationStatusForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: StaffApplicationStatusFormProps) => {
  const form = useForm<StaffApplicationStatusInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput<StaffApplicationStatusEnum>
                    options={Object.values(StaffApplicationStatusEnum).map((status) => ({
                      label: staffApplicationStatusEnumMapping[status].label,
                      value: status
                    }))}
                    dropDownPosition="above"
                    label={'Statut'}
                    selectedOption={getSelectedOption(
                      field.value,
                      staffApplicationStatusEnumMapping[field.value].label
                    )}
                    onChange={(value) => form.setValue('status', value, { shouldValidate: true })}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default StaffApplicationStatusForm
